"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var EventImpl = require("./Event-impl").implementation;

var StorageEventInit = require("../generated/StorageEventInit"); // https://html.spec.whatwg.org/multipage/webstorage.html#the-storageevent-interface


var StorageEventImpl =
/*#__PURE__*/
function (_EventImpl) {
  _inherits(StorageEventImpl, _EventImpl);

  function StorageEventImpl() {
    _classCallCheck(this, StorageEventImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(StorageEventImpl).apply(this, arguments));
  }

  _createClass(StorageEventImpl, [{
    key: "initStorageEvent",
    value: function initStorageEvent(type, bubbles, cancelable, key, oldValue, newValue, url, storageArea) {
      if (this._dispatchFlag) {
        return;
      }

      this.initEvent(type, bubbles, cancelable);
      this.key = key;
      this.oldValue = oldValue;
      this.newValue = newValue;
      this.url = url;
      this.storageArea = storageArea;
    }
  }]);

  return StorageEventImpl;
}(EventImpl);

StorageEventImpl.defaultInit = StorageEventInit.convert(undefined);
module.exports = {
  implementation: StorageEventImpl
};